export default {
  state: {
    statusSelect: [
      {
        name: "Ativo",
        value: "null",
      },
      {
        name: "Inativo",
        value: "not_null",
      },
    ],
  },

  getters: {
    getStatus(state) {
      return state.statusSelect;
    },
  },
};
